module.exports = require("@fullcalendar/list");